import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";

// The shared panel surface: one border, one radius, one shadow, so the tables,
// galleries and stat tiles stop each inventing their own.
function SurfaceCard({ children, sx, padded }) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #e3e8f0",
        borderRadius: 2,
        bgcolor: "#fff",
        p: padded ? { xs: 2, md: 2.5 } : 0,
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}

SurfaceCard.defaultProps = { sx: {}, padded: true };

SurfaceCard.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.object,
  padded: PropTypes.bool,
};

export default SurfaceCard;
